import ReactDOM from 'react-dom';
import App from './App';
import './default-styles.css';

ReactDOM.render(<App />, document.getElementById('root'));
